import { type ReactNode } from 'react';
import { FaCircleExclamation } from 'react-icons/fa6';
import { Typography } from '@breezeai-frontend/cargo-ui';

import { type ExclusionReason } from '../../../model/Quote';

export function ExclusionReasons({
  reasons,
  title,
}: {
  reasons: ExclusionReason[];
  title?: ReactNode;
}) {
  if (!reasons.length) return null;

  return (
    <div className="flex flex-col gap-2">
      {title ?? (
        // eslint-disable-next-line i18next/no-literal-string -- TODO fix localization
        <Typography customStyles="text-text-tertiary font-bold">
          Exceptions:
        </Typography>
      )}
      {reasons.map(({ name, value }) => (
        <div
          key={`${name}-${value}`}
          className="text-sm flex gap-2 items-center"
        >
          <FaCircleExclamation className="w-3.5 h-3.5 text-system-red-500 shrink-0" />
          <Typography customStyles="text-sm text-nowrap text-text-tertiary">
            {name}
          </Typography>
          <Typography customStyles="text-sm text-text-secondary">
            {value}
          </Typography>
        </div>
      ))}
    </div>
  );
}
